import { z } from 'zod';
import { FlowCustomSubtaskParsedConfigSchema, FlowHumanTaskDynamicConfigParsedConfigSchema, FlowSubmitPriorAuthorizationParsedConfigSchema, } from '../flowDefinition/blocks/humanTask/parsedConfig.js';
import { PatientOrderMixedDetermination, TerminalAuthorizationStatus, } from '../patientOrder/authorizationStatus.js';
export const HumanTaskAssetPayloadSchema = z.object({
    name: z.string(),
    contentType: z.string(),
    content: z.string(),
});
export const HumanTaskAssetResponseSchema = z.object({
    success: z.boolean(),
    fileReference: z.string(),
});
export const HumanTaskSubtaskStepPayloadSchema = z.object({
    stepValues: z.record(z.string(), z.string().or(z.array(z.string()))),
});
export const HumanTaskPayloadSchema = z.object({
    subtaskValues: z.array(z.record(z.string(), z.string().or(z.array(z.string())))),
    metadata: z.object({
        userId: z.uuid().optional(),
        startedAt: z.string().optional(),
        completedAt: z.string().optional(),
        subtasks: z.array(z.object({
            title: z.string(),
            steps: z
                .array(z
                .object({
                title: z.string(),
                completedAt: z.string(),
            })
                .nullable())
                .optional(),
            procedureId: z.uuid().optional(),
        })),
        updatedSubmissions: z.array(z.record(z.string(), z.unknown())).optional(),
        authorizationStatus: z
            .enum(TerminalAuthorizationStatus)
            .or(z.literal(PatientOrderMixedDetermination.MixedDetermination).optional()),
    }),
});
export const HumanTaskParsedConfigSchema = z.discriminatedUnion('taskType', [
    FlowCustomSubtaskParsedConfigSchema,
    FlowHumanTaskDynamicConfigParsedConfigSchema,
    FlowSubmitPriorAuthorizationParsedConfigSchema,
]);
//# sourceMappingURL=payload.js.map